<span class="shepherd-step-counter">
  {{ 'SHEPHERD_MODAL_STEP_PROGRESS' | translate: { stepCount, stepNumber } }}
</span>
